import * as React from "react";
import { Component } from "react";

import "./App.css";

import { Buffer } from "buffer";
import { IMaskInput } from "react-imask";
import ICalendarLink from "react-icalendar-link";
import queryString from "query-string";
import { zonedTimeToUtc } from "date-fns-tz";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

import phoneLogo from "./img/CallbackPhone.png";
import calendarImg from "./img/add-to-calendar.png";
import { shouldForwardProp } from "@mui/styled-engine";

//they said they don't want these, so...
//import callReasons from './callreasons.json';

const mainTheme = createTheme({
  type: "light",
  palette: {
    primary: {
      main: "#1d5c42",
    },
    secondary: {
      main: blue[500],
    },
    //only worth using if you're not changing divider size; use component thing as seen below
    //divider: '#434d64',
    background: {
      paper: "#eeeeee",
    },
  },
  typography: {
    h3: {
      fontSize: "2.5rem",
      textAlign: "center",
    },
    h4: {
      fontSize: "1.75rem",
      textAlign: "center",
      marginBottom: 20,
    },
    h5: {
      fontSize: "1.1rem",
      color: "#5da401",
    },
    body1: {
      textAlign: "center",
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          textAlign: "left",
          cursor: "auto",
          padding: 10,
          marginTop: 10,
          marginBottom: 10,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          background: "#434d64",
          width: "100%",
          height: 2,
          marginTop: 10,
          marginBottom: 10,
        },
      },
    },
    MuiStepButton: {
      styleOverrides: {
        root: {
          cursor: "auto",
        },
      },
    },
    /*
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          width: 400
        }
      }
        //do this in the .css since cursor doesn't work on this element
        root: ({ ownerState }) => ({
          ...(ownerState.disabled === true && {
              backgroundColor: '#eeeeee',
              color: '#fff',
              cursor: 'not-allowed'
            }),
        }),
      },
      
    },
    */
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginTop: 10,
          marginBottom: 10,
          display: "grid",
        },
      },
    },
    /*
    MuiMenuItem: {
      styleOverrides: {
        root: {
          width: 450,
        }
      }
    },
    */
    MuiList: {
      styleOverrides: {
        root: {
          display: "inline-block",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          margin: 1,
        },
      },
    },
  },
});

const phoneInput = React.forwardRef(function TextMaskCustom(props, ref) {
  const phoneMask = "+1 (#00) 000-0000";
  return (
    <IMaskInput
      {...props}
      mask={phoneMask}
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
    />
  );
});

const emailInput = React.forwardRef(function TextMaskCustom(props, ref) {
  const emailMask = /^\S*@?\S*$/;
  return (
    <IMaskInput
      {...props}
      mask={emailMask}
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
    />
  );
});

const ReviewBlurb = (firstName, day, time, phone) => {
  const nameString = firstName ? firstName + ", w" : "W";

  return (
    <>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="body1">
          {nameString}e'll call you at this date and approximate time to help
          you with your questions.
        </Typography>
        <List dense>
          <ListItem>{day}</ListItem>
          <ListItem>{time}</ListItem>
          <ListItem>{phone}</ListItem>
        </List>
      </Box>
    </>
  );
};

class App extends Component {
  constructor(props) {
    super(props);

    let initialFormObj = {
      altered: false,
      value: "",
      error: "",
      delayTimeout: false,
    };

    this.state = {
      // token: false,
      activeStep: 0,
      completed: {},
      firstName: "",
      scheduleOptions: [],
      calendarData: {},
      formInfoCallReasonSelect: initialFormObj,
      formInfoDaySelect: initialFormObj,
      formInfoTimeSelect: initialFormObj,
      formInfoPhoneInput: initialFormObj,
      formReviewEmailCheck: false,
      formReviewEmailInput: initialFormObj,
      scheduleID: false,
      disableAllActive: true,
      loadingBackdropActive: true,
      dialogs: [],
    };

    this.steps = ["", "", ""];

    this.stepCanProceed = [];

    //get web id from url paramaters
    const urlParams = window?.location?.search;

    this.webID =
      urlParams && queryString.parse(urlParams)?.webID?.length > 0
        ? queryString.parse(urlParams).webID
        : false;

    this.apiKey = process.env.REACT_APP_API_KEY;

    this.apiUrl =
      process.env.REACT_APP_ENVIRONMENT &&
      process.env.REACT_APP_ENVIRONMENT === "Dev"
        ? process.env.REACT_APP_DEV_CRUD_ENDPOINT
        : process.env.REACT_APP_PROD_CRUD_ENDPOINT;

    this.appNameID =
      process.env.REACT_APP_ENVIRONMENT &&
      process.env.REACT_APP_ENVIRONMENT === "Dev"
        ? process.env.REACT_APP_DEV_APPNAMEID
        : process.env.REACT_APP_PROD_APPNAMEID;

    // this.appNameID =
    //   process.env?.REACT_APP_APPNAMEID &&
    //   process.env.REACT_APP_APPNAMEID?.length > 0
    //     ? process.env.REACT_APP_APPNAMEID
    //     : "";

    this.environment =
      process.env?.REACT_APP_ENVIRONMENT &&
      process.env.REACT_APP_ENVIRONMENT?.length > 0
        ? process.env.REACT_APP_ENVIRONMENT
        : "";
  }

  componentDidMount = async () => {
    //const token = await this.getToken();

    // let token = "FakeToken123";

    //  if (token) {
    //this.setState({ token: token }, async () => {
    const readTimesResponse = await this.readTimes(
      this.webID
      // this.state.token
    );

    if (readTimesResponse) {
      const firstName = readTimesResponse?.responseBody?.[0]?.data
        ?.returnData?.[0]?.Customer_First_Name
        ? readTimesResponse.responseBody[0].data.returnData[0]
            .Customer_First_Name
        : "";

      const scheduleOptions = readTimesResponse?.responseBody?.[0]?.data
        ?.returnData?.[0]?.scheduleOptions
        ? readTimesResponse.responseBody[0].data.returnData[0].scheduleOptions
        : [];

      if (scheduleOptions?.length > 0) {
        this.setState({
          firstName: firstName,
          scheduleOptions: scheduleOptions,
          loadingBackdropActive: false,
          disableAllActive: false,
        });
      } else {
        this.openDialog(
          "We're sorry, it looks like there are currently no available times.  Please try again later."
        );
      }
    }
    // });
    //  }
  };

  // getToken = async (attempts = 1) => {
  //   try {
  //     if (attempts > 5) {
  //       throw new Error("Exceeded max token generation attempts.");
  //     }

  //     this.apiUrl =
  //     process.env.NODE_ENV && process.env.NODE_ENV === "development"
  //       ? process.env.DEV_CRUD_ENDPOINT
  //       : process.env.PROD_CRUD_ENDPOINT;

  //     const apiOptions = {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     };

  //     let token = false;

  //     const fetchResponse = await fetch(apiUrl, apiOptions).then((response) => {
  //       if (!response?.status || response.status !== 200) {
  //         throw response;
  //       }

  //       token = response?.headers?.has("access_token")
  //         ? response.headers.get("access_token")
  //         : token;

  //       return response;
  //     });

  //     let response;

  //     response = fetchResponse && (await fetchResponse.json());

  //     return token;
  //   } catch (error) {
  //     console.error(
  //       `Error retrieving from token endpoint (Attempt #${attempts}): `,
  //       error
  //     );
  //     if (attempts < 5) {
  //       setTimeout(() => {
  //         this.getToken(++attempts);
  //       }, 5000);
  //     } else {
  //       this.openDialog("Error loading page-- please try again later!");
  //       this.setState({ loadingBackdropActive: false });
  //       return false;
  //     }
  //   }
  // };

  readTimes = async (
    webID, //token,
    attempts = 1
  ) => {
    try {
      if (!webID) {
        throw new Error("No webID passed");
      }

      // if (!token) {
      //   throw new Error("No token passed");
      // }

      let apiBody = {
        CRUD_Action: "subProcedure",
        procedureAction: "read",
        appNameID: this.appNameID,
        appID: "wsc.com",
        isUAT: 1,
        Environment: this.environment,
        webID: webID,
      };

      console.log(this.apiUrl);
      console.log(apiBody);
      const apiOptions = {
        method: "POST",
        body: JSON.stringify(apiBody),
        headers: {
          "Content-Type": "application/json",
          // Key: new Buffer.from(this.apiKey).toString("base64"),
          //   Token: token,
        },
      };

      const fetchResponse = await fetch(this.apiUrl, apiOptions);

      let response;

      response = fetchResponse && (await fetchResponse.json());

      //adjust response to fit existing conditional
      response = { responseBody: response };

      if (!response?.responseBody?.[0]?.isSuccess) {
        let errorMsg =
          response?.responseBody?.[0]?.statusMessage?.length > 0
            ? response.responseBody[0].statusMessage
            : "Error loading page-- please try again later!";
        throw new Error(errorMsg);
      }

      return response;
    } catch (error) {
      console.error(`Error retrieving read (Attempt #${attempts}): ${error}`);
      if (attempts < 3) {
        setTimeout(() => {
          this.readTimes(
            webID, //token,
            ++attempts
          );
        }, 5000);
      } else {
        this.openDialog("Error loading page-- please try again later!");
        this.setState({ loadingBackdropActive: false });
      }
    }
  };

  reserveTime = async (
    webID,
    // token,
    attempts = 1
  ) => {
    let newState = {
      ...this.state,
      disableAllActive: false,
      loadingBackdropActive: false,
    };

    try {
      this.setState({ disableAllActive: true, loadingBackdropActive: true });

      if (!webID) {
        throw new Error("No webID passed");
      }

      // if (!token) {
      //   throw new Error("No token passed");
      // }

      if (
        !this.state.formInfoDaySelect?.value?.length ||
        this.state.formInfoDaySelect.value.length < 1
      ) {
        let errorStr = "Error with day selection-- try refreshing the page!";
        console.error(errorStr);
        this.openDialog(errorStr);
        this.setState({
          disableAllActive: false,
          loadingBackdropActive: false,
        });
        return false;
      }

      if (
        !this.state.formInfoTimeSelect?.value?.length ||
        this.state.formInfoTimeSelect.value.length < 1
      ) {
        let errorStr = "Error with time selection-- try refreshing the page!";
        console.error(errorStr);
        this.openDialog(errorStr);
        this.setState({
          disableAllActive: false,
          loadingBackdropActive: false,
        });
        return false;
      }

      let apiBody = {
        CRUD_Action: "subProcedure",
        procedureAction: "reserve",
        appNameID: this.appNameID,
        appID: "wsc.com",
        isUAT: 1,
        Environment: this.environment,
        webID: webID,
        scheduleDate: this.state.formInfoDaySelect.value,
        scheduleTime: this.state.formInfoTimeSelect.value,
      };

      console.log(apiBody);

      const apiOptions = {
        method: "POST",
        body: JSON.stringify(apiBody),
        headers: {
          "Content-Type": "application/json",
          //Key: new Buffer.from(this.apiKey).toString("base64"),
          // Token: token,
        },
      };

      const fetchResponse = await fetch(this.apiUrl, apiOptions);

      let response;

      response = fetchResponse && (await fetchResponse.json());

      //adjust response to fit existing conditional
      response = { responseBody: response };

      if (!response?.responseBody?.[0]?.isSuccess) {
        let errorMsg =
          response?.responseBody?.[0]?.statusMessage?.length > 0
            ? response.responseBody[0].statusMessage
            : "Error loading page-- please try again later!";
        throw new Error(errorMsg);
      }
      if (
        response?.responseBody?.[0]?.data?.returnData?.[0]?.scheduleOptions
          ?.length &&
        response.responseBody[0].data.returnData[0].scheduleOptions.length > 0
      ) {
        newState.scheduleOptions =
          response.responseBody[0].data.returnData[0].scheduleOptions;
      }

      if (
        !response?.responseBody?.[0]?.data?.requestStatus?.length ||
        response.responseBody[0].data.requestStatus.length < 1 ||
        response.responseBody[0].data.requestStatus.toLowerCase() !== "success"
      ) {
        let errorStr =
          response?.responseBody?.[0]?.data?.requestMessage?.length &&
          response.responseBody[0].data.requestMessage.length > 0
            ? response.responseBody[0].data.requestMessage
            : "Unable to reserve time-- please try again!";
        console.error(errorStr);

        newState.formInfoDaySelect.value = "";
        newState.formInfoTimeSelect.value = "";

        this.setState(newState, () => {
          this.openDialog(errorStr);
        });
        return false;
      }

      if (
        !response?.responseBody?.[0]?.data?.scheduleID ||
        ("" + response.responseBody[0].data.scheduleID)?.length < 1
      ) {
        newState.formInfoDaySelect.value = "";
        newState.formInfoTimeSelect.value = "";
        throw "Response didn't include a schedule ID.";
      }

      this.setState(newState);

      return response.responseBody[0].data.scheduleID;
    } catch (error) {
      console.error(`Error retrieving reserve: `, error);
      this.openDialog("Error reserving time-- please try again later!");
      this.setState(newState);
      return false;
    }
  };

  unlockTime = async (
    webID,
    // token,
    attempts = 1
  ) => {
    let newState = {
      ...this.state,
      disableAllActive: false,
      loadingBackdropActive: false,
    };

    try {
      this.setState({ disableAllActive: true, loadingBackdropActive: true });

      if (!webID) {
        throw new Error("No webID passed");
      }

      // if (!token) {
      //   throw new Error("No token passed");
      // }

      if (!this.state.scheduleID) {
        let errorStr =
          "Error unlocking your reservation-- try refreshing the page!";
        console.error(errorStr);
        this.openDialog(errorStr);
        this.setState({ loadingBackdropActive: false });
        return false;
      }

      let apiBody = {
        CRUD_Action: "subProcedure",
        procedureAction: "unlock",
        appNameID: this.appNameID,
        appID: "wsc.com",
        isUAT: 1,
        Environment: this.environment,
        webID: webID,
        scheduleID: this.state.scheduleID,
      };

      console.log(apiBody);

      const apiOptions = {
        method: "POST",
        body: JSON.stringify(apiBody),
        headers: {
          "Content-Type": "application/json",
          // Key: new Buffer.from(this.apiKey).toString("base64"),
          // Token: token,
        },
      };

      const fetchResponse = await fetch(this.apiUrl, apiOptions);

      let response;

      response = fetchResponse && (await fetchResponse.json());
      //adjust response to fit existing conditional
      response = { responseBody: response };

      if (!response?.responseBody?.[0]?.isSuccess) {
        let errorMsg =
          response?.responseBody?.[0]?.statusMessage?.length > 0
            ? response.responseBody[0].statusMessage
            : "Error loading page-- please try again later!";
        throw new Error(errorMsg);
      }

      if (
        response?.responseBody?.[0]?.data?.returnData?.[0]?.scheduleOptions
          ?.length &&
        response.responseBody[0].data.returnData[0].scheduleOptions.length > 0
      ) {
        newState.scheduleOptions =
          response.responseBody[0].data.returnData[0].scheduleOptions;
      } else {
        throw new Error(
          "We're sorry, it looks like there are currently no available times.  Please try again later."
        );
      }

      if (
        !response?.responseBody?.[0]?.data?.requestStatus?.length ||
        response.responseBody[0].data.requestStatus.length < 1 ||
        response.responseBody[0].data.requestStatus.toLowerCase() !== "success"
      ) {
        let errorStr =
          response?.responseBody?.[0]?.data?.requestMessage?.length &&
          response.responseBody[0].data.requestMessage.length > 0
            ? response.responseBody[0].data.requestMessage
            : "Unable to unlock reservation-- please try again!";
        console.error(errorStr);

        this.setState(newState, () => {
          this.openDialog(errorStr);
        });
        return false;
      }

      this.setState(newState);

      return true;
    } catch (error) {
      console.error(`Error retrieving unlock: `, error);
      this.openDialog("Error unlocking time-- please try again!");
      this.setState(newState);
      return false;
    }
  };

  scheduleTime = async (
    webID,
    // token,
    attempts = 1
  ) => {
    let newState = {
      ...this.state,
      disableAllActive: false,
      loadingBackdropActive: false,
    };

    try {
      this.setState({ disableAllActive: true, loadingBackdropActive: true });

      if (!webID) {
        throw new Error("No webID passed");
      }

      // if (!token) {
      //   throw new Error("No token passed");
      // }

      if (!this.state.scheduleID) {
        let errorStr =
          "Error scheduling your callback-- try refreshing the page!";
        console.error(errorStr);
        this.openDialog(errorStr);
        this.setState({ loadingBackdropActive: false });
        return false;
      }

      if (
        !this.state.formInfoPhoneInput?.value?.length ||
        this.state.formInfoPhoneInput.value.length < 1
      ) {
        let errorStr =
          "Error scheduling your callback-- try refreshing the page!";
        console.error(errorStr);
        this.openDialog(errorStr);
        this.setState({
          disableAllActive: false,
          loadingBackdropActive: false,
        });
        return false;
      }

      let submissionPhone = this.state.formInfoPhoneInput.value
        .replaceAll(" ", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "");

      let apiBody = {
        CRUD_Action: "subProcedure",
        procedureAction: "schedule",
        appNameID: this.appNameID,
        appID: "wsc.com",
        isUAT: 1,
        Environment: this.environment,
        webID: webID,
        scheduleID: this.state.scheduleID,
        scheduleDate: this.state.formInfoDaySelect.value,
        scheduleTime: this.state.formInfoTimeSelect.value,
        phoneNumber: submissionPhone,
        emailAddr: this.state.formReviewEmailInput.value,
      };

      console.log(apiBody);

      const apiOptions = {
        method: "POST",
        body: JSON.stringify(apiBody),
        headers: {
          "Content-Type": "application/json",
          // Key: new Buffer.from(this.apiKey).toString("base64"),
          // Token: token,
        },
      };

      const fetchResponse = await fetch(this.apiUrl, apiOptions);

      let response;

      response = fetchResponse && (await fetchResponse.json());

      //adjust response to fit existing conditional
      response = { responseBody: response };

      if (
        response?.responseBody?.[0]?.data?.returnData?.[0]?.scheduleOptions
          ?.length &&
        response.responseBody[0].data.returnData[0].scheduleOptions.length > 0
      ) {
        newState.scheduleOptions =
          response.responseBody[0].data.returnData[0].scheduleOptions;
      }

      if (
        !response?.responseBody?.[0]?.data?.requestStatus?.length ||
        response.responseBody[0].data.requestStatus.length < 1 ||
        response.responseBody[0].data.requestStatus.toLowerCase() !== "success"
      ) {
        let errorStr =
          response?.responseBody?.[0]?.data?.requestMessage?.length &&
          response.responseBody[0].data.requestMessage.length > 0
            ? response.responseBody[0].data.requestMessage
            : "Unable to reserve time-- please try again!";
        console.error(errorStr);

        this.setState(newState, () => {
          this.openDialog(errorStr);
        });
        return false;
      }

      this.setState(newState);

      return true;
    } catch (error) {
      console.error(`Error retrieving schedule: `, error);
      this.openDialog(
        "Error scheduling your callback-- please try again later!"
      );
      this.setState(newState);
      return false;
    }
  };

  openDialog = (text, title = "") => {
    let dialogsArr = this.state.dialogs;

    dialogsArr.push({
      title: title,
      text: text,
      open: true,
    });

    this.setState({ ...this.state, dialogs: dialogsArr });
  };

  closeDialog = (index, event) => {
    let dialogsArr = this.state.dialogs;

    dialogsArr.splice(index, 1);

    this.setState({ ...this.state, dialogs: dialogsArr });
  };

  setActiveStep = (step) => {
    this.setState({ ...this.state, activeStep: step });
  };

  setCompleted = (completed) => {
    this.setState({ ...this.state, completed: completed });
  };

  totalSteps = () => {
    return this.steps.length;
  };

  completedSteps = () => {
    return Object.keys(this.state.completed).length;
  };

  isLastStep = () => {
    return this.state.activeStep === this.totalSteps() - 1;
  };

  allStepsCompleted = () => {
    return this.completedSteps() === this.totalSteps();
  };

  isValidFormSelect = (selectName) => {
    return this.state[selectName].value.length > 0;
  };

  isValidFormInfoPhoneInput = () => {
    return this.state.formInfoPhoneInput.value.replace(/\D/g, "").length >= 11;
  };

  isValidFormReviewEmail = () => {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
      this.state.formReviewEmailInput.value
    );
  };

  isFirstStepComplete = () => {
    //they don't want reason anymore, so comment out at least for now
    //return this.isValidFormSelect("formInfoCallReasonSelect") && this.isValidFormSelect("formInfoDaySelect") && this.isValidFormSelect("formInfoTimeSelect") && this.isValidFormInfoPhoneInput();
    return (
      this.isValidFormSelect("formInfoDaySelect") &&
      this.isValidFormSelect("formInfoTimeSelect") &&
      this.isValidFormInfoPhoneInput()
    );
  };

  isSecondStepComplete = () => {
    return (
      !this.state.formReviewEmailCheck ||
      (this.state.formReviewEmailCheck && this.isValidFormReviewEmail())
    );
  };

  handleNext = async () => {
    let scheduleID = false;

    //check current step before proceeding, bail if we have issues reserving/scheduling/etc.
    switch (this.state.activeStep) {
      case 0:
        scheduleID = await this.reserveTime(
          this.webID
          // this.state.token
        );
        if (!scheduleID) {
          return false;
        }
        break;
      case 1:
        let scheduleSuccess = await this.scheduleTime(
          this.webID
          // this.state.token
        );
        if (!scheduleSuccess) {
          return false;
        }
        break;
    }

    const newCompleted = this.state.completed;
    newCompleted[this.state.activeStep] = true;
    if (this.state.activeStep === 1) {
      newCompleted[this.state.activeStep + 1] = true;
    }

    const newActiveStep =
      this.isLastStep() && !this.allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          this.steps.findIndex((step, i) => !(i in this.state.completed))
        : this.state.activeStep + 1;

    let calendarData = {};

    if (
      this.state.formInfoDaySelect.value.length > 0 &&
      this.state.formInfoTimeSelect.value.length > 0
    ) {
      let timeObj = this.getCalendarTimes(
        this.state.formInfoDaySelect.value,
        this.state.formInfoTimeSelect.value
      );

      //just hardcoding for now
      let descVerbiage =
        "During our appointment, we’ll discuss your objectives and work together to determine how we can best help you to successfully navigate your path to financial success.\\n";
      descVerbiage += "\\n";
      descVerbiage +=
        "To get the most out of your scheduled call, you can prepare by…\\n";
      descVerbiage += "\\n";
      descVerbiage +=
        " - Adding this appointment to your calendar and setting a reminder so you’re ready when we call\\n";
      descVerbiage +=
        " - Having any relevant loan documentation handy (i.e., billing statement, payment history, etc.)\\n";
      descVerbiage +=
        " - Gathering household income documentation if you’re seeking a lower monthly payment\\n";
      descVerbiage += "\\n";
      descVerbiage +=
        "We’re looking forward to speaking with you. Until then, feel free to visit our Help Center (https://servicing.mohela.com/loan-servicing/help-center/) for answers to commonly asked questions, “how to” demonstrations and videos about student loan basics.";

      calendarData = {
        title: "MOHELA Consultation",
        description: descVerbiage,
        startTime: timeObj.startTime,
        endTime: timeObj.endTime,
        location: "We'll call you",
        attendees: ["CustomerService@servicing.mohela.com"],
      };
    }

    this.setState({
      ...this.state,
      scheduleID: scheduleID ? scheduleID : this.state.scheduleID,
      activeStep: newActiveStep,
      completed: newCompleted,
      calendarData: calendarData,
      disableAllActive: false,
      loadingBackdropActive: false,
    });
  };

  handleBack = async () => {
    //check current step before proceeding, bail if we have issues unlocking/etc.
    switch (this.state.activeStep) {
      case 1:
        let unlockSuccess = await this.unlockTime(
          this.webID
          // this.state.token
        );
        if (!unlockSuccess) {
          return false;
        }
        break;
    }

    const newCompleted = this.state.completed;
    delete newCompleted[this.state.activeStep - 1];

    this.state.activeStep <= 1
      ? this.setState(
          {
            //I hate this but yolo
            ...this.state,
            disableAllActive: false,
            loadingBackdropActive: false,
          },
          () => {
            this.handleReset();
          }
        )
      : this.setState({
          ...this.state,
          activeStep: this.state.activeStep - 1,
          completed: newCompleted,
          disableAllActive: false,
          loadingBackdropActive: false,
        });
  };

  handleClose = () => {};

  handleStep = (step) => () => {
    this.setActiveStep(step);
  };

  handleReset = () => {
    let daySelect = this.state.formInfoDaySelect;
    daySelect.value = "";

    let timeSelect = this.state.formInfoTimeSelect;
    timeSelect.value = "";

    this.setState({
      ...this.state,
      formInfoDaySelect: daySelect,
      formInfoTimeSelect: timeSelect,
      activeStep: 0,
      completed: {},
    });
  };

  handleFormChange = (event) => {
    let newObj = {
      ...this.state[event.target.name],
      altered: true,
      value: event.target.value.trim(),
    };

    let newState = {
      [event.target.name]: newObj,
    };

    //reset time if date is changed
    if (event.target.name === "formInfoDaySelect") {
      newState.formInfoTimeSelect = {
        ...this.state[event.target.name],
        altered: false,
        value: "",
      };
    }

    this.setState(newState, () => {
      if (event.target.name.includes("Input")) {
        clearTimeout(this.state[event.target.name].delayTimeout);
        let newDelayedInputObj = this.state[event.target.name];

        newDelayedInputObj.delayTimeout = setTimeout(() => {
          this.validateForm(event, true);
        }, 1000);

        this.setState({ [event.target.name]: newDelayedInputObj });
      } else {
        this.validateForm(event);
      }
    });
  };

  handleCheckChange = (event) => {
    let newState = {
      ...this.state,
      [event.target.name]: this.state[event.target.name] ? false : true,
    };

    //clear email and error if this is an uncheck
    if (
      event.target.name === "formReviewEmailCheck" &&
      this.state.formReviewEmailCheck === true
    ) {
      newState.formReviewEmailInput.value = "";
      newState.formReviewEmailInput.error = "";
    }

    this.setState(newState);
  };

  validateForm = (event, isDelayed = false) => {
    let newState = { ...this.state };

    let selectNames = [
      "formInfoCallReasonSelect",
      "formInfoDaySelect",
      "formInfoTimeSelect",
    ];

    selectNames.forEach((selectName) => {
      newState[selectName].error =
        !this.isValidFormSelect(selectName) && this.state[selectName].altered
          ? "Please select an option."
          : "";
    });

    if (
      event.target.name === "formInfoPhoneInput" &&
      (event.type === "blur" || isDelayed)
    ) {
      newState.formInfoPhoneInput.error =
        !this.isValidFormInfoPhoneInput() &&
        this.state.formInfoPhoneInput.altered
          ? "Please enter a valid US phone number."
          : "";
    }

    if (
      event.target.name === "formReviewEmailInput" &&
      (event.type === "blur" || isDelayed)
    ) {
      newState.formReviewEmailInput.error =
        !this.isValidFormReviewEmail() &&
        this.state.formReviewEmailInput.altered &&
        this.state.formReviewEmailCheck
          ? "Please enter a valid email address."
          : "";
    }

    this.setState(newState);
  };

  nextDisabled = (step) => {
    switch (step) {
      case 0:
        return !this.isFirstStepComplete();
      case 1:
        return !this.isSecondStepComplete();
      default:
        return false;
    }
  };

  getTimes = (date) => {
    let scheduleOptions = [];

    this.state.scheduleOptions.every((entryObj) => {
      if (date === entryObj.scheduleDate) {
        scheduleOptions = entryObj.scheduleTime;
        return false;
      }
      return true;
    });

    return scheduleOptions;
  };

  getCalendarTimes = (date, time) => {
    let startTimeUtc = zonedTimeToUtc(`${date} ${time}`, "America/New_York");

    let startTimeDate = new Date(startTimeUtc);

    let endTimeDate = new Date(startTimeUtc);

    endTimeDate.setMinutes(endTimeDate.getMinutes() + 15);

    return {
      startTime: startTimeDate,
      endTime: endTimeDate,
    };
  };

  formatDate = (date, time) => {
    let dateStr = zonedTimeToUtc(`${date} ${time}`, "America/New_York");
    let formattedDate = new Date(dateStr);
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    return formattedDate.toLocaleDateString("en-us", options);
  };

  formatTime = (time) => {
    time = time.split(":");

    let hour = parseInt(time[0]);
    let minute = parseInt(time[1]);

    let amOrPm = hour >= 12 ? "p.m." : "a.m.";

    let standardHour = hour > 12 ? hour - 12 : hour;

    let standardMin = minute < 10 ? "0" + minute : minute;

    return standardHour + ":" + standardMin + " " + amOrPm + " ET";
  };

  render() {
    return (
      <ThemeProvider theme={mainTheme}>
        <Box className="App">
          <Typography variant="h3">
            <img src={phoneLogo} className="App-logo" alt="logo" /> Schedule a
            Call Back
          </Typography>
          <Divider />
          <Stepper nonLinear activeStep={this.state.activeStep}>
            {this.steps.map((label, index) => (
              <Step key={index} completed={this.state.completed[index]}>
                <StepButton color="inherit">{label}</StepButton>
              </Step>
            ))}
          </Stepper>
          {this.state.activeStep === 0 ? (
            <Box>
              <Typography variant="h4">Provide Your Information</Typography>
              {/* they said they don't want this, so
                    <FormControl error={this.state.formInfoCallReasonSelect.error.length > 0}>
                      <InputLabel id="call-reasons-select-label">Select a reason for the call</InputLabel>
                      <Select
                        id="call-reasons-select"
                        labelId="call-reasons-select-label"
                        label="Select a reason for the call"
                        name="formInfoCallReasonSelect"
                        value={this.state.formInfoCallReasonSelect.value}
                        onChange={this.handleFormChange.bind(this)}
                        disabled={this.state.disableAllActive}
                      >
                        <MenuItem value="">&nbsp;</MenuItem>
                        {callReasons.map((reason, index) => (
                          <MenuItem key={index} value={reason}>{reason}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{this.state.formInfoCallReasonSelect.error}</FormHelperText>
                    </FormControl>
                  */}
              <FormControl
                error={this.state.formInfoDaySelect.error.length > 0}
              >
                <InputLabel id="day-select-label">Select a day</InputLabel>
                <Select
                  id="day-select"
                  labelId="day-select-label"
                  label="Select a day"
                  name="formInfoDaySelect"
                  value={this.state.formInfoDaySelect.value}
                  onChange={this.handleFormChange.bind(this)}
                  disabled={this.state.disableAllActive}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  {this.state.scheduleOptions.map((entryObj, index) => (
                    <MenuItem key={index} value={entryObj.scheduleDate}>
                      {this.formatDate(
                        entryObj.scheduleDate,
                        entryObj.scheduleTime
                      )}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {this.state.formInfoDaySelect.error}
                </FormHelperText>
              </FormControl>
              <FormControl
                error={this.state.formInfoTimeSelect.error.length > 0}
              >
                <InputLabel id="time-select-label">
                  Select a time (may be approximate)
                </InputLabel>
                <Select
                  id="time-select"
                  labelId="time-select-label"
                  label="Select a time (may be approximate)"
                  name="formInfoTimeSelect"
                  value={this.state.formInfoTimeSelect.value}
                  disabled={
                    this.state.formInfoDaySelect.value.length < 1 ||
                    this.state.disableAllActive
                  }
                  onChange={this.handleFormChange.bind(this)}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  {this.getTimes(this.state.formInfoDaySelect.value).map(
                    (time, index) => (
                      <MenuItem key={index} value={time}>
                        {this.formatTime(time)}
                      </MenuItem>
                    )
                  )}
                </Select>
                <FormHelperText>
                  {this.state.formInfoTimeSelect.error}
                </FormHelperText>
              </FormControl>
              <FormControl
                error={this.state.formInfoPhoneInput.error.length > 0}
              >
                <InputLabel id="phone-input-label">
                  Phone number for us to call
                </InputLabel>
                <OutlinedInput
                  id="phone-input"
                  label="Phone number for us to call"
                  variant="outlined"
                  name="formInfoPhoneInput"
                  onBlur={this.handleFormChange.bind(this)}
                  onInput={this.handleFormChange.bind(this)}
                  value={this.state.formInfoPhoneInput.value}
                  inputComponent={phoneInput}
                  disabled={this.state.disableAllActive}
                />
                <FormHelperText>
                  {this.state.formInfoPhoneInput.error}
                </FormHelperText>
              </FormControl>
            </Box>
          ) : this.state.activeStep === 1 ? (
            <Box>
              <Typography variant="h4">Review and Submit</Typography>
              {ReviewBlurb(
                this.state.firstName,
                this.formatDate(
                  this.state.formInfoDaySelect.value,
                  this.state.formInfoTimeSelect.value
                ),
                this.formatTime(this.state.formInfoTimeSelect.value),
                this.state.formInfoPhoneInput.value
              )}
              <Card>
                <Typography variant="h6">
                  If you provided a cell number...
                </Typography>
                <Typography variant="body2">
                  By providing a cell phone number, you give us permission to
                  call it, using an automated dialing device and prerecorded
                  messages.
                </Typography>
              </Card>
              <FormControl>
                <FormControlLabel
                  id="email-check-label"
                  label="Please send a confirmation email to:"
                  control={
                    <Checkbox
                      size="small"
                      color="secondary"
                      name="formReviewEmailCheck"
                      checked={this.state.formReviewEmailCheck}
                      onChange={this.handleCheckChange.bind(this)}
                      disabled={this.state.disableAllActive}
                    />
                  }
                  labelPlacement="end"
                />
              </FormControl>
              <FormControl
                error={this.state.formReviewEmailInput.error.length > 0}
              >
                <InputLabel id="email-input-label">Email Address</InputLabel>
                <OutlinedInput
                  id="email-input"
                  label="Email Address"
                  variant="outlined"
                  name="formReviewEmailInput"
                  onBlur={this.handleFormChange.bind(this)}
                  onInput={this.handleFormChange.bind(this)}
                  value={this.state.formReviewEmailInput.value}
                  inputComponent={emailInput}
                  placeholder="user@domain.com"
                  disabled={
                    !this.state.formReviewEmailCheck ||
                    this.state.disableAllActive
                  }
                />
                <FormHelperText>
                  {this.state.formReviewEmailInput.error}
                </FormHelperText>
              </FormControl>
            </Box>
          ) : this.state.activeStep === 2 ? (
            <Box>
              <Box>
                <Typography variant="h4">Thank You!</Typography>
              </Box>
              {ReviewBlurb(
                this.state.firstName,
                this.formatDate(this.state.formInfoDaySelect.value),
                this.formatTime(this.state.formInfoTimeSelect.value),
                this.state.formInfoPhoneInput.value
              )}
              <Divider sx={{ bgcolor: "primary.main" }} />
              <ICalendarLink
                event={this.state.calendarData}
                filename="Mohela Consultation.ics"
                className="calendarLink"
              >
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(12, 1fr)"
                  gap={2}
                >
                  <Box gridColumn="span 4" sx={{ textAlign: "center" }}>
                    <img
                      src={calendarImg}
                      className="calendar-img"
                      alt="calendar"
                    />
                  </Box>
                  <Box gridColumn="span 8">
                    <Typography variant="h5">
                      Please mark your calendar with this information.
                    </Typography>
                    <Typography variant="body1" sx={{ textAlign: "left" }}>
                      We look forward to speaking with you.
                    </Typography>
                  </Box>
                </Box>
              </ICalendarLink>
              <Divider sx={{ bgcolor: "primary.main" }} />
            </Box>
          ) : (
            ""
          )}
          {this.completedSteps() === this.totalSteps() ? (
            //just leaving in the event they want some way to close from here
            <Box>
              <Button
                onClick={this.handleClose}
                disabled={this.state.disableAllActive}
                sx={{ display: "none" }}
              >
                Close
              </Button>
            </Box>
          ) : (
            <Box>
              <Button
                startIcon={this.completedSteps() === 0 ? "" : <ArrowBackIcon />}
                variant="outlined"
                color="inherit"
                disabled={this.state.disableAllActive}
                onClick={
                  this.completedSteps() === 0
                    ? this.handleClose
                    : this.handleBack
                }
                sx={this.completedSteps() === 0 ? { display: "none" } : {}}
              >
                {this.completedSteps() === 0 ? "Cancel" : "Back"}
              </Button>
              <Button
                endIcon={
                  this.completedSteps() === 0 ? (
                    <ArrowForwardIcon />
                  ) : this.completedSteps() === this.totalSteps() ? (
                    <CloseIcon />
                  ) : (
                    ""
                  )
                }
                variant="contained"
                color={
                  this.completedSteps() === this.totalSteps() - 2
                    ? "success"
                    : "primary"
                }
                disabled={
                  this.nextDisabled(this.state.activeStep) ||
                  this.state.disableAllActive
                }
                sx={{ m: 2 }}
                onClick={this.handleNext}
              >
                {this.completedSteps() === this.totalSteps() - 2
                  ? "Submit"
                  : "Next"}
              </Button>
            </Box>
          )}
        </Box>
        <Backdrop open={this.state.loadingBackdropActive}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {this.state.dialogs.map((dialogObj, dialogInd) => (
          <Dialog
            open={dialogObj.open}
            onClose={this.closeDialog.bind(this, dialogInd)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            key={dialogInd}
          >
            <DialogTitle id={`alert-dialog-title-${dialogInd}`}>
              {dialogObj?.title && dialogObj?.title?.length > 0
                ? dialogObj.title
                : ""}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {dialogObj?.text && dialogObj?.text?.length > 0
                  ? dialogObj.text
                  : ""}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeDialog.bind(this, dialogInd)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        ))}
      </ThemeProvider>
    );
  }
}

export default App;
